"use client";

import { useEffect } from "react";

// Kok layout'larin kendisi hata verdiginde gosterilir; bu yuzden kendi
// <html>/<body> etiketlerini icerir ve harici bilesen kullanmaz.
export default function GlobalError({
    error,
    reset,
}: {
    error: Error & { digest?: string };
    reset: () => void;
}) {
    useEffect(() => {
        console.error(error);
    }, [error]);

    return (
        <html lang="tr">
            <body
                style={{
                    margin: 0,
                    minHeight: "100vh",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "#051e3c",
                    color: "#fff",
                    fontFamily: "system-ui, -apple-system, Segoe UI, Roboto, sans-serif",
                    textAlign: "center",
                    padding: 16,
                }}
            >
                <div style={{ maxWidth: 420 }}>
                    <h1 style={{ fontSize: 28, marginBottom: 8 }}>Bir şeyler ters gitti</h1>
                    <p style={{ opacity: 0.7, marginBottom: 4 }}>Something went wrong. Please try again.</p>
                    {error.digest ? (
                        <p style={{ opacity: 0.4, fontFamily: "monospace", fontSize: 12 }}>#{error.digest}</p>
                    ) : null}
                    <button
                        onClick={() => reset()}
                        style={{
                            marginTop: 20,
                            padding: "10px 24px",
                            border: 0,
                            borderRadius: 6,
                            background: "#00AEEF",
                            color: "#fff",
                            fontWeight: 600,
                            cursor: "pointer",
                        }}
                    >
                        Tekrar dene / Try again
                    </button>
                </div>
            </body>
        </html>
    );
}
